<template>
  <div class="reserve-receivers-editor">
    <el-table :data="rows" border stripe size="small">
      <el-table-column label="微信商户号" min-width="200">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.merchant_no"
            size="small"
            placeholder="必填，分账接收方商户号"
            @input="emit"
          />
        </template>
      </el-table-column>
      <el-table-column label="商户名称" min-width="180">
        <template slot-scope="scope">
          <el-input
            v-model="scope.row.merchant_name"
            size="small"
            placeholder="商户全称（选填）"
            @input="emit"
          />
        </template>
      </el-table-column>
      <el-table-column label="占订单总额（小数）" width="220">
        <template slot-scope="scope">
          <el-input-number
            v-model="scope.row.percent"
            size="small"
            :min="0"
            :max="1"
            :precision="4"
            :controls="false"
            style="width: 100%"
            @change="emit"
          />
        </template>
      </el-table-column>
      <el-table-column label="操作" width="80" align="center">
        <template slot-scope="scope">
          <el-button type="text" size="mini" icon="el-icon-delete" @click="removeRow(scope.$index)" />
        </template>
      </el-table-column>
    </el-table>

    <div class="editor-toolbar">
      <el-button type="text" size="small" icon="el-icon-plus" @click="addRow">添加账户</el-button>
      <span class="rate-tip">
        预留奖励总额比例：<b>{{ reserveRateText }}</b>
        ｜ 当前各账户合计：<b :class="percentValid ? 'ok' : 'warn'">{{ totalPercentText }}</b>
        <span v-if="!percentValid" class="warn-tip">（应等于总额比例，当前不一致）</span>
      </span>
      <span class="unit-tip">单位说明：均为小数，与"预留奖励比例（总额）"一致，如 0.01 表示 1%。各账户之和应等于总额比例。</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ReserveReceiversEditor',
  props: {
    // value 为 JSON 字符串，内部 percent 存小数（如 0.01 = 1%）
    value: { type: String, default: '' },
    // reserveRate 为小数（如 0.01 = 1%）
    reserveRate: { type: [String, Number], default: '0.01' }
  },
  data() {
    return {
      rows: []
    }
  },
  computed: {
    // 总额比例以小数展示（0.01 = 1%）
    reserveRateText() {
      const rate = parseFloat(this.reserveRate)
      if (isNaN(rate)) return '-'
      return String(this.round(rate))
    },
    // rows 中 percent 为小数，合计直接累加
    totalPercent() {
      return this.rows.reduce((sum, r) => sum + (parseFloat(r.percent) || 0), 0)
    },
    totalPercentText() {
      return String(this.round(this.totalPercent))
    },
    // 各账户小数之和应与总额比例（小数）一致
    percentValid() {
      const rate = parseFloat(this.reserveRate)
      if (isNaN(rate)) return true
      return Math.abs(this.totalPercent - rate) < 0.0001
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(v) {
        this.parse(v)
      }
    }
  },
  methods: {
    round(n) {
      return Math.round(n * 10000) / 10000
    },
    parse(v) {
      try {
        const arr = JSON.parse(v || '[]')
        if (Array.isArray(arr)) {
          this.rows = arr.map(r => ({
            merchant_no: (r.merchant_no || '').toString(),
            merchant_name: (r.merchant_name || '').toString(),
            // 小数直接展示，与存储一致
            percent: parseFloat(r.percent) || 0
          }))
        } else {
          this.rows = []
        }
      } catch (e) {
        this.rows = []
      }
    },
    addRow() {
      this.rows.push({ merchant_no: '', merchant_name: '', percent: 0 })
      this.emit()
    },
    removeRow(index) {
      this.rows.splice(index, 1)
      this.emit()
    },
    emit() {
      const payload = this.rows
        .filter(r => (r.merchant_no && r.merchant_no.trim()) || r.merchant_name)
        .map(r => ({
          merchant_no: (r.merchant_no || '').trim(),
          merchant_name: (r.merchant_name || '').trim(),
          // 小数直接存储，与 commission_reserve_rate 单位一致（0.01 = 1%）
          percent: this.round(parseFloat(r.percent) || 0)
        }))
      this.$emit('input', JSON.stringify(payload))
    }
  }
}
</script>

<style scoped>
.editor-toolbar {
  margin-top: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
}
.rate-tip {
  font-size: 12px;
  color: #606266;
}
.rate-tip b.ok {
  color: #67c23a;
}
.rate-tip b.warn {
  color: #e6a23c;
}
.warn-tip {
  color: #e6a23c;
  margin-left: 4px;
}
.unit-tip {
  font-size: 12px;
  color: #909399;
  margin-left: 8px;
}
</style>
